// режим увеличения изображения
const ZOOM_STATE = {
  // подгоняется под размер слайда
  FIT: 0,
  // показывается в максимальном разрешении  
  MAXSIZE: 1
};

// import {ZOOM_STATE} from '@scripts/ImageViewer/Constants.js';

class Slide {

  /**
   * @typedef {Object} imageData
   * @property {String} src - Image Src.
   * @property {String} width - Image Width.
   * @property {String} height - Image Height. 
   * @property {String} caption - Image Caption.
   */  

   /**
    * 
    * @param {Layout} layout Разметка, в которой находится слайд
    * @param {HTMLElement} slide
    */
  constructor(layout, slide) {
    this.layout = layout;
    this.slide = slide;
    this.zoom = slide.children[0];
    this.img = this.zoom.children[0];

    this.slideData = {
      zoomState: ZOOM_STATE.FIT,
      imageWidth: null,
      imageHeight: null,
      slideOffsetX: 0,
      slideOffsetY: 0,
      zoomOffsetX: 0,
      zoomOffsetY: 0,
      moveOffsetX: 0,
      moveOffsetY: 0,
    };

    this._setImageZoomHandlers();        
    this.img.addEventListener('click', this._handleImageClick.bind(this));    
  }

  _handleImageClick() {
    if (this.slideData.zoomState == ZOOM_STATE.FIT) {
      this.zoomIn();  
    }
  }

  _setImageZoomHandlers() {
    let isDragging = false;
    let startPoint = {};
    let handleMouseMove = _handleMouseMove.bind(this);
      
    this.img.onmousedown = handleMouseDown.bind(this);

    this.img.ondragstart = function() {
      return false;
    };


    function handleMouseDown(e) {
      const {zoomState} = this.slideData;
      
      if (zoomState != ZOOM_STATE.MAXSIZE) {
        return
      }
        
      isDragging = true;

      startPoint = {
        x: e.clientX,
        y: e.clientY
      };

      document.addEventListener('mousemove', handleMouseMove);
      this.img.onmouseup = handleMouseUp.bind(this);
    }

    function _handleMouseMove(e) {

      if (isDragging){
        // e.preventDefault();

        Object.assign(this.slideData, {
          moveOffsetX: e.clientX - startPoint.x,
          moveOffsetY: e.clientY - startPoint.y
        });

        this._drawSlide();
      }
    }

    function handleMouseUp(e) {
      if (isDragging){
        document.removeEventListener('mousemove', handleMouseMove);

        const {
          zoomOffsetX, zoomOffsetY,
          moveOffsetX, moveOffsetY
        } = this.slideData;

        Object.assign(this.slideData, {
          zoomOffsetX: zoomOffsetX + moveOffsetX,
          zoomOffsetY: zoomOffsetY + moveOffsetY,
          moveOffsetX: 0,
          moveOffsetY: 0
        });
        
        // e.preventDefault();
        this.img.onmouseup = null;
        isDragging = false;
      }
    }
    
  }


  /**
   * Устанавливает изображение внутри слайда
   * @param {imageData} imageData Информация об устанавливаемом изображении
   */
  setImage(imageData) {
    this.imageData = imageData;
    this.img.src = imageData.src;
    this.zoomOut();
  }

  /**
   * Устанавливает необходимые смещения и размеры элементов слайда
   * для существующего режима увеличения изображения
   */
  _updateSize() {
    if (!this.imageData) return;    

    const {
      zoomState
    } = this.slideData;

    switch (zoomState) {
      case ZOOM_STATE.FIT:
        Object.assign(this.slideData, this._getImageFitSize());
        break;

      case ZOOM_STATE.MAXSIZE:
        Object.assign(this.slideData, this._getImageMaxSize());
        break;
    }
  }
  
  /**
   * Расчитывает необходимые размеры и смещения, чтобы изображение вписалось в слайд
   */
  _getImageFitSize() {
    if (!this.imageData) return;
    const image = this.imageData;

    const {slideWidth, slideHeight} = this._getSlideSize();
    
    // console.log(slideWidth, slideHeight);

    let fitRatio = Math.min(slideWidth/image.width, slideHeight/image.height);
    
    if (fitRatio > 1)  fitRatio = 1;
    
    const imageFitWidth = fitRatio * image.width,
          imageFitHeight = fitRatio * image.height;
    
    return {
      imageWidth:  Math.round(imageFitWidth),
      imageHeight:  Math.round(imageFitHeight),
      slideOffsetX: Math.round(slideWidth/2 - imageFitWidth/2),
      slideOffsetY: Math.round(slideHeight/2 - imageFitHeight/2),
      zoomOffsetX: 0,
      zoomOffsetY: 0,
      moveOffsetX: 0,
      moveOffsetY: 0,
      zoomState: ZOOM_STATE.FIT
    }
  }

  /**
   * Расчитывает необходимые размеры и смещения, чтобы изображение показывалось
   * в максимальном разрешении
   */
  _getImageMaxSize() {
    if (!this.imageData) return;
    const image = this.imageData;

    const {slideWidth, slideHeight} = this._getSlideSize();
    // console.log(slideWidth, slideHeight);

    return {
      imageWidth:  image.width,
      imageHeight:  image.height,
      zoomOffsetX: Math.round(slideWidth/2 - image.width/2),
      zoomOffsetY: Math.round(slideHeight/2 - image.height/2),
      slideOffsetX: 0,
      slideOffsetY: 0,
      moveOffsetX: 0,
      moveOffsetY: 0,
      zoomState: ZOOM_STATE.MAXSIZE
    }
  }

  _draw() {
    this._drawImage();
    this._drawSlide();
  }

  _drawImage() {
    const {
      imageWidth, imageHeight
    } = this.slideData;

    this.img.style.width = imageWidth + 'px';
    this.img.style.height = imageHeight + 'px';
    // this.img.style.display = 'block';        
  }


  _drawSlide() {
    const {
      zoomOffsetX, zoomOffsetY,
      slideOffsetX, slideOffsetY,
      moveOffsetX, moveOffsetY,
      zoomState
    } = this.slideData;

    if (zoomState == ZOOM_STATE.MAXSIZE) {
      this._setTranslate(zoomOffsetX + moveOffsetX, zoomOffsetY+ moveOffsetY, this.zoom.style);
      this._setTranslate(0, 0, this.slide.style);
    }
    else {
      this._setTranslate(slideOffsetX, slideOffsetY, this.slide.style);
      this._setTranslate(0, 0, this.zoom.style);
    }
  }

  handleWindowResize() {
    this._updateSize();
    this._draw();
  }

  _getSlideSize() {
    return {
      slideWidth: document.documentElement.clientWidth,
      // document.documentElement.clientHeight - doesn't seem to work well
      slideHeight: window.innerHeight,
    }
  }

	_setTranslate = function(x, y, elStyle) {
    elStyle['transform'] = `translate3d(${x}px, ${y}px, 0)`; 
	}


  /**
   * Показывает изображение в максимальном разрешении
   */
  zoomIn() {
    Object.assign(this.slideData, this._getImageMaxSize());
    this._draw();
    this.layout.setZoomState(this.slideData.zoomState);
  }

  /**
   * Показывает изображение с подгонкой под размер слайда
   */
  zoomOut() {
    Object.assign(this.slideData, this._getImageFitSize());
    this._draw();
    this.layout.setZoomState(this.slideData.zoomState);
  }

  getZoomState() {
    return this.slideData.zoomState;
  }
}

// import Slide from '@scripts/ImageViewer/Slide.js';
  
class Layout {

  /**
   * 
   * @param {ImageViewer} iv 
   */
  constructor(iv) {
    this.iv = iv;
  }

  build() {
    const viewer = document.createElement('div');
    viewer.id = "iv";
    viewer.className = "iv";
    viewer.innerHTML = this._getInnerHTML();

    const slides = viewer.querySelectorAll(`.iv__slides .iv__slide`); 
    this.slides = [];
    slides.forEach(function(slide) {
      this.slides.push(new Slide(this, slide));
    }, this);    

    this.counter = viewer.querySelector(`.iv__counter`);
    this.caption = viewer.querySelector(`.iv__caption`);
    this.loadingIcon = viewer.querySelector(`.loading`);
    this.prevBtn = viewer.querySelector(`.iv__button--arrow-left`);
    this.nextBtn = viewer.querySelector(`.iv__button--arrow-right`);
    this.zoomBtn = viewer.querySelector(`.iv__button--zoom`);
    this.closeBtn = viewer.querySelector(`.iv__button--close`);
    this.viewer = viewer;

    return this.viewer;
  }

  /**
   * Видно ли окно просмотра в браузере
   */
  isVisible() {
    return this.viewer.classList.contains('iv--opened');
  }  

  /**
   * Показывает окно просмотра
   */
  show() {
    // hiding by ESC
    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        if (this.isVisible()) {
          this.hide();
          e.preventDefault();	
          return;
        }
      }
    });

    const scrollBarWidth = window.innerWidth - document.body.offsetWidth;
    document.body.style.margin = '0px ' + scrollBarWidth + 'px 0px 0px';
    document.body.style.overflow = 'hidden';
    this.viewer.classList.add('iv--opened');
  }

  /**
   * Скрывает окно просмотра
   */
  hide() {
    document.body.style.margin = '';
    document.body.style.overflow = '';
    this.viewer.classList.remove('iv--opened');
  }

  activateLoading() {
    // this.preloader.classList.add('preloader--active');
    this.viewer.classList.add('iv--is-loading');
  }

  deactivateLoading() {
    // this.preloader.classList.remove('preloader--active');    
    this.viewer.classList.remove('iv--is-loading');
  }

  /**
   * Управляет видимостью кнопки показа предыдущего слайда 
   * @param {Boolean} show 
   */
  setPrevBtnVisibility(show) {
    (show) ?
      this.prevBtn.classList.remove('iv__button--hidden'):
      this.prevBtn.classList.add('iv__button--hidden');
  }
  
  /**
   * Управляет видимостью кнопки показа следующего слайда 
   * @param {Boolean} show 
   */
  setNextBtnVisibility(show) {
    (show) ?
      this.nextBtn.classList.remove('iv__button--hidden'):
      this.nextBtn.classList.add('iv__button--hidden');
  };


  setZoomState(zoomState) {
    switch (zoomState) {
      case ZOOM_STATE.FIT:
        this.viewer.classList.remove('iv--zoomed-in');
        this.viewer.classList.add('iv--zoom-allowed');        
        break;

      case ZOOM_STATE.MAXSIZE:
        this.viewer.classList.add('iv--zoomed-in');
        this.viewer.classList.remove('iv--zoom-allowed');        
        break;
    }
  }

  /**
   * Устанавливает порядковый номер активного изображения
   * @param {Number} current Порядковый номер активного изображения
   * @param {Number} total Общее количество изображений
   */
  setCounter(current, total) {
    this.counter.textContent = `${current} / ${total}`;
  }

  /**
   * Устанавливает описание для изображения
   * @param {String} value 
   */
  setCaption(value) {
    this.caption.textContent = value;
  }

  /**
   * Устанавливает изображение в активный слайд
   * @param {Image} image 
   */
  setActiveImage(image) {
    const activeSlide = this.getActiveSlide();
    activeSlide.setImage(image);
    // this.zoomState = ZOOM_STATE.FIT;
  }


  handleWindowResize() {
    if (this.isVisible()) {
      const activeSlide = this.getActiveSlide();
      activeSlide.handleWindowResize();
    }
  }

  /**
   * Переключает режим увеличения активного слайда
   */
  zoom() {
    const activeSlide = this.getActiveSlide();
    switch (activeSlide.getZoomState()) {
      case ZOOM_STATE.FIT:
        activeSlide.zoomIn();
        break;

      case ZOOM_STATE.MAXSIZE:
        activeSlide.zoomOut();
        break;
    }
  }


  /**
   * Возвращает ссылку на активный слайд
   * @returns {Slide} 
   */
  getActiveSlide() {
    return this.slides[0];
  }

  getSlide(slideType) {
    return this.slides[0];
  }


  _getInnerHTML() {
    return '<div class="iv__bg"></div>'
    + '<div class="iv__wrapper">'
      + '<div class="iv__slides">'
        + '<div class="iv__slide">'
          + '<div class="iv__zoom-wrapper">'
            + '<img class="iv__img" src="">'
          + '</div>'
        + '</div>'
      + '</div>'
      + '<div class="iv__controls">'
        + '<div class="iv__top-bar">'
          + '<div class="iv__counter"></div>'
          + '<button class="iv__button iv__button--close" title="Close (Esc)"></button>'
          + '<button class="iv__button iv__button--zoom" title="Zoom in/out"></button>'
        + '</div>'
        + '<button class="iv__button iv__button--arrow-left" title="Previous (arrow left)"></button>'
        + '<button class="iv__button iv__button--arrow-right" title="Next (arrow right)"></button>'
        + '<div class="iv__bottom-bar">'
          + '<div class="iv__caption"></div>'
        + '</div>'
      + '</div>'
      + '<div class="loading">'
      + '<div class="loading__icon">'
        + '<div class="loading__cut">'
          + '<div class="loading__donut"></div>'
        + '</div>'
      + '</div>'
    + '</div>'
    + '</div>'
  
    
  }
}

class SlideList {

  /**
   * @typedef {Object} slideData
   * @property {String} src - Image Src.
   * @property {String} caption - Image Caption.
   */  

  /**
   * 
   * @param {ImageViewer} iv 
   */
  constructor(iv) {
    this.iv = iv;
  }

  /**
   * Инициализация перед использованием
   * @param {Array<slideData>} data 
   */
  init(data) {
    this.slides = data;
  }

  getImageSrc(slideIndex) {
    return this.slides[slideIndex].src;
  }

  getImageCaption(slideIndex) {
    return this.slides[slideIndex].caption;
  }

  numberOfSlides() {
    return this.slides.length;
  }
}

// import Layout from '@scripts/ImageViewer/Layout.js';

class ImageViewer {

  constructor() {
    this.layout = new Layout(this);
    this.slideList = new SlideList(this);
    this.init();
  }

  init() {
    if (this._ready) {
      return;
    }
    
    // создаем и добавляем html-разметку viewerа на страницу
    const viewer = this.layout.build();
    document.body.appendChild(viewer);

    // this.preload = {};
    this.preload = new Image();
    this.handleActiveImageOnload = this._handleActiveImageOnload.bind(this);    

    this.preloadPrev = new Image();
    this.preloadNext = new Image();
    
    this.activeSlide = this.prevSlide = this.nextSlide = -1;
    this.activeSrc = '';

    this._setHandlers();
    this._ready = true;
  }  

  /**
   * 
   * @param {Array<slideData>} slides 
   * @param {*} startIndex 
   */
  open(slides, startIndex) {
    // console.log('Показываю', slides, ', начиная c', startIndex);

    this.layout.show();
    this.slideList.init(slides);
    this.changeSlide(startIndex);
  }


  _setHandlers() {
    this.layout.closeBtn.addEventListener('click', this._handleCloseBtnClick.bind(this));
    this.layout.prevBtn.addEventListener('click', this._handlePrevBtnClick.bind(this));
    this.layout.nextBtn.addEventListener('click', this._handleNextBtnClick.bind(this));
    this.layout.zoomBtn.addEventListener('click', this._handleZoomBtnClick.bind(this));
    window.addEventListener('resize', this._handleWindowResize.bind(this));
  }
  
	changeSlide(slideIndex) {
		if (slideIndex >= 0) {
			this.activeIndex = slideIndex;
			this.activeSrc = this.slideList.getImageSrc(this.activeIndex);
			this.prevIndex = (this.activeIndex || 0) - 1;
			this.nextIndex = ((this.activeIndex + 1) % this.slideList.numberOfSlides()) || -1;

			this.stopPreloading();
      
      this.layout.activateLoading();
      // this.preload = new Image();
      // this.preload.onload = this._handleActiveImageOnload.bind(this);
			this.preload.onload = this.handleActiveImageOnload;
			this.preload.src = this.activeSrc;
		}
	}
  

  _handleActiveImageOnload() {
    this.layout.deactivateLoading();
    this.layout.setPrevBtnVisibility(this.prevIndex != -1);
    this.layout.setNextBtnVisibility(this.nextIndex != -1);
    this.startPreloading();
    this.layout.setActiveImage(this.preload);
    this.layout.setCaption(this.slideList.getImageCaption(this.activeIndex));
    this.layout.setCounter(this.activeIndex+1, this.slideList.numberOfSlides());
  }

  startPreloading() {
    if (this.prevIndex >= 0) this.preloadPrev.src = this.slideList.getImageSrc(this.prevIndex);
		if (this.nextIndex >= 0) this.preloadNext.src = this.slideList.getImageSrc(this.nextIndex);
  }

  stopPreloading() {
    this.preload.onload = null;
    this.preload.src = this.preloadPrev.src = this.preloadNext.src = this.activeSrc;
  }

  _handleCloseBtnClick() {
    if (this.activeIndex >= 0) {
      this.stopPreloading();
      this.activeIndex = this.prevIndex = this.nextIndex = -1;
      this.layout.hide();
    }
  }

  _handlePrevBtnClick() {
    return this.changeSlide(this.prevIndex);
  }

  _handleNextBtnClick() {
    return this.changeSlide(this.nextIndex);
  }

  _handleZoomBtnClick() {
    return this.layout.zoom();
  }

  _handleWindowResize() {
    this.layout.handleWindowResize();
  }  
}

export { ImageViewer as default };
